module.exports = __webpack_public_path__ + "static/media/L diag area.1cbf34a2.kra";